import CheckboxFieldBase from '../base/CheckboxField';
import createField from './createField';

const CheckboxField = createField(CheckboxFieldBase);

export default CheckboxField;
